import { apiFetch } from "./client.js";

export async function approvePendingTransfer(rowKey: string): Promise<{ ok: true }> {
  return apiFetch<{ ok: true }>(`/api/pending-transfers/${encodeURIComponent(rowKey)}/approve`, {
    method: "POST",
  });
}

export async function rejectPendingTransfer(rowKey: string): Promise<{ ok: true }> {
  return apiFetch<{ ok: true }>(`/api/pending-transfers/${encodeURIComponent(rowKey)}/reject`, {
    method: "POST",
  });
}
